import { UserAddressDTO } from './user-address'

export interface OrganizationDTO {
  id: number
  externalId: string
  name: string
  children: OrganizationDTO[]
}

export enum Sex {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export enum UserRoleName {
  SUPER_ADMIN = 'SUPER_ADMIN',
  STORE_ADMIN = 'STORE_ADMIN',
  SALES_ASSISTANT = 'SALES_ASSISTANT',
  VIEWER = 'VIEWER'
}

export interface ShippingGeoCountriesDTO {
  id: number
  status: string
  createdDate?: string
  name: string
}

export interface ShippingBillingAddressDTO {
  country: string
  city: string
  address: string
  zipcode: string
  id?: number
}

export interface AddressesDTO {
  name: string
  id?: number
  shippingAddress: ShippingBillingAddressDTO
  billingAddress: ShippingBillingAddressDTO
  primary: boolean
}
export interface CredicCardsDTO {
  expDate: string
  externalId: string
  id: number | string
  name: string
  number: string
  scv: string,
  cardType: number
}

export interface UserRoleDTO {
  id: number
  label: string
  name: UserRoleName
  permissions: any
  priority: number
}

export interface UserDTO {
  addresses: UserAddressDTO[]
  changePasswordCode: string
  created: string
  createdBy: UserDTO
  currency: string
  dateOfBirth: string
  emailAddress: string
  externalId: string
  firstName: string
  id: number
  imageUrl: string
  language: string
  lastName: string
  marketplaceId: number
  organizations: OrganizationDTO[]
  phoneNumber: string
  roles: UserRoleDTO[]
  role: UserRoleDTO
  sex: Sex | string
  creditCards?: CredicCardsDTO[]
  password?: string;
  newPassword?: string;
}
